import React from "react";
import { Switch, Textarea } from "@panda0/panda0-ui";
import { Video } from "lucide-react";
import { Controller, useFormContext } from "react-hook-form";

import { FormData } from "../types";

const VideoResumeEditor: React.FC = () => {
  const { control, watch } = useFormContext<FormData>();
  const isEnabled = watch("videoResume.QUIZSUBMISSION_VIDEO_RESUME") || false;

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        Configure if candidates should submit a video resume along with their
        pandaquiz.
      </p>

      <div className="flex items-center justify-between mb-4">
        <label className="font-medium">Enable Video Resume</label>
        <Controller
          name="videoResume.QUIZSUBMISSION_VIDEO_RESUME"
          control={control}
          render={({ field }) => (
            <Switch
              checked={field.value || false}
              fn={(checked) => field.onChange(checked)}
            />
          )}
        />
      </div>

      {isEnabled && (
        <div className="space-y-4">
          <div className="p-4 border rounded-md bg-gray-50">
            <div className="flex items-center mb-4">
              <Video className="h-5 w-5 mr-2 text-primary" />
              <h3 className="font-medium">Video Resume Instructions</h3>
            </div>
            <Controller
              name="videoResume.QUIZSUBMISSION_VIDEO_RESUME_INSTRUCTIONS"
              control={control}
              render={({ field }) => (
                <Textarea
                  placeholder="Instructions for candidates recording a video resume..."
                  className="min-h-[120px]"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              )}
            />
            <p className="mt-2 text-sm text-gray-500">
              Provide clear instructions for candidates about what to include in
              their video resume.
            </p>
          </div>

          <div className="space-y-2">
            <h3 className="font-medium">Video Settings</h3>
            <div className="flex items-center justify-between">
              <label className="text-sm">Maximum Duration</label>
              <Controller
                name="videoResume.QUIZSUBMISSION_VIDEO_RESUME_MAXDURATION"
                control={control}
                render={({ field }) => (
                  <select
                    className="border rounded p-1"
                    value={field.value || "120"}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    <option value="60">1 minute</option>
                    <option value="120">2 minutes</option>
                  </select>
                )}
              />
            </div>
          </div>

          <div className="p-4 border border-yellow-200 bg-yellow-50 rounded-md">
            <p className="text-sm text-yellow-800">
              <strong>Note:</strong> Candidates will need to allow camera and
              microphone access to record their video resume.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(VideoResumeEditor);
